import React from "react";
import {
  Box, Card, CardContent, CircularProgress, Table, TableBody,
  TableCell, TableHead, TableRow, Typography, TextField, InputAdornment, Stack,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface Col<T> { header: string; render: (row: T) => React.ReactNode; }
interface Props<T> {
  title: string; subtitle?: string;
  columns: Col<T>[]; rows: T[]; loading: boolean;
  search?: string; onSearch?: (v: string) => void; searchPlaceholder?: string;
  empty?: string;
  onRowClick?: (row: T) => void;
}

export function DataTablePage<T>({ title, subtitle, columns, rows, loading, search, onSearch, searchPlaceholder, empty, onRowClick }: Props<T>) {
  return (
    <Box>
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} spacing={1} sx={{ mb: 2 }}>
        <Box>
          <Typography variant="h4">{title}</Typography>
          {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
        </Box>
        {onSearch && (
          <TextField size="small" placeholder={searchPlaceholder || "Search..."} value={search}
            onChange={(e) => onSearch(e.target.value)} sx={{ minWidth: 260 }}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
        )}
      </Stack>
      <Card>
        <CardContent>
          {loading ? (
            <Box sx={{ display: "grid", placeItems: "center", py: 6 }}><CircularProgress /></Box>
          ) : rows.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ py: 4, textAlign: "center" }}>{empty || "No records found."}</Typography>
          ) : (
            <Box sx={{ overflowX: "auto" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>{columns.map((c) => <TableCell key={c.header} sx={{ color: "text.secondary", fontWeight: 700 }}>{c.header}</TableCell>)}</TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, i) => (
                    <TableRow key={i} hover onClick={onRowClick ? () => onRowClick(row) : undefined} sx={onRowClick ? { cursor: "pointer" } : undefined}>{columns.map((c) => <TableCell key={c.header}>{c.render(row)}</TableCell>)}</TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
export default DataTablePage;
